import { Card, CardContent } from "@/components/ui/card";
import { Application } from "@/types/startup";

interface ApplicationCardProps {
  application: Application;
  onClick: () => void;
}

export const ApplicationCard = ({ application, onClick }: ApplicationCardProps) => {
  return (
    <Card 
      className="bg-black/30 hover:bg-black/40 transition-colors cursor-pointer"
      onClick={onClick}
    >
      <CardContent className="flex items-center justify-between p-4">
        <div className="flex items-center space-x-4">
          <div className="flex-shrink-0">
            {application.profiles.avatar_url ? (
              <img
                src={application.profiles.avatar_url}
                alt=""
                className="h-10 w-10 rounded-full"
              />
            ) : (
              <div className="h-10 w-10 rounded-full bg-flux-cyan/20" />
            )}
          </div>
          <div>
            <p className="font-medium">{application.profiles.full_name}</p>
            <p className="text-sm text-gray-400">
              Applied for {application.startup_roles.title} at {application.startups.name}
            </p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <span className={`px-2 py-1 rounded-full text-xs ${
            application.status === 'pending' ? 'bg-yellow-500/20 text-yellow-500' :
            application.status === 'accepted' ? 'bg-green-500/20 text-green-500' :
            application.status === 'rejected' ? 'bg-red-500/20 text-red-500' :
            'bg-blue-500/20 text-blue-500'
          }`}>
            {application.status.charAt(0).toUpperCase() + application.status.slice(1)}
          </span>
        </div>
      </CardContent>
    </Card>
  );
};